<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <v-form
        ref="form"
        class="multi-col-validation mt-6"
      >
        <v-row>
          <v-col cols="12">
            <span class="text--secondary">
              Что писать в журнал обмена. Записи видно в карточке заказа и на странице
              «Обмен с внешними системами»; у обменов без заказа — например, у синхронизации
              справочников — карточки нет, они видны только на странице.
            </span>
          </v-col>

          <v-col cols="12">
            <v-switch
              v-model="rk7"
              label="Касса"
              hint="Заказы и справочники. Ответы по меню на сотни килобайт — на время синхронизации запись лучше снимать"
              persistent-hint
              class="mt-0"
            ></v-switch>
          </v-col>

          <v-col cols="12">
            <v-switch
              v-model="crm"
              label="CRM"
              hint="Поиск гостя, заведение карточки и адреса. С этого начинается каждое оформление"
              persistent-hint
              class="mt-0"
            ></v-switch>
          </v-col>

          <v-col cols="12">
            <v-switch
              v-model="delivery"
              label="Delivery"
              hint="Заказы, меню, адреса. Тела тяжёлые — включайте на время разбора"
              persistent-hint
              class="mt-0"
            ></v-switch>
          </v-col>

          <v-col cols="12">
            <v-switch
              v-model="bakai"
              label="Bakai"
              hint="Платёжные ссылки и QR, вместе с отказами и временем ответа"
              persistent-hint
              class="mt-0"
            ></v-switch>
          </v-col>

          <v-col cols="12">
            <v-alert
              text
              color="info"
              dense
            >
              Касса и CRM пишутся по умолчанию: разбор оформления без них слепой. Delivery и
              банк по умолчанию выключены — в их обмене целые заказы, ссылки и QR.
            </v-alert>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              @click="saveData"
            >
              Сохранить
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              type="reset"
              @click="cancel"
            >
              Отмена
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'

export default {
  name: 'ExchangeLogSettingForm',
  computed: {
    ...mapFormHandlers('exchangeLogSettings', ['delivery', 'bakai', 'crm', 'rk7']),
  },
  async created() {
    await this.fetch()
  },
  methods: {
    ...mapActions('exchangeLogSettings', ['update', 'fetch']),
    cancel() {
      this.$router.back()
    },
    async saveData() {
      await this.update()
    },
  },
}
</script>
